module.exports = __webpack_public_path__ + "img/Ursa_major.4d367dfc.png";